import { BaseResponse, RequestConfig } from 'common/types/api'
import axios from 'core/api'

import { Unit } from './types'

export const COST_REQUEST_CONFIG: RequestConfig = {
  get: { method: 'GET', url: '/cost' },
  createCategory: { method: 'POST', url: '/cost' },
  createSubcategory: { method: 'POST', url: '/cost/category/subcategory' },
  editCategory: { method: 'PATCH', url: '/cost/category' },
  deleteCategory: { method: 'DELETE', url: '/cost/category' },
  deleteSubcategory: { method: 'DELETE', url: '/cost/category/subcategory' },
  editSequence: { method: 'PATCH', url: '/cost/category/sequence' },
  editSubcategory: { method: 'PATCH', url: '/cost/category/subcategory' },
  edit: { method: 'PATCH', url: '/cost' },
  saveFoodPrice: { method: 'PATCH', url: '/cost/category/food' },
  saveShrimpPrice: { method: 'PATCH', url: '/cost/category/shrimp' },
  saveMedicinePrice: { method: 'PATCH', url: '/cost/category/medicine' },
}

export const getUnits = () => axios.get<BaseResponse<Unit[]>>(`/units`)


export const COST_TRANSACTION: RequestConfig = {
  getList: { method: 'GET', url: '/cost/transaction/history' },
  getById: { method: 'GET', url: '/cost/transaction' },
  create: { method: 'POST', url: '/cost/transaction' },
  update: { method: 'PATCH', url: '/cost/transaction' },
  delete: { method: 'DELETE', url: '/cost/transaction' },
  getPieChart: { method: 'GET', url: '/cost/transaction/pie-chart' },
  getStackChart: { method: 'GET', url: '/cost/transaction/stack-chart' },
  getTransactionCategoryList: { method: 'GET', url: '/cost/transaction/category-list' },
  getTransactionLinechart: { method: 'GET', url: '/cost/transaction/line-chart' },
  categoryList: { method: 'GET', url: '/cost/category-list' },
  createCategory: { method: 'POST', url: '/cost/category' },
  editCategory: { method: 'PATCH', url: '/cost/category' },
  getGroup: { method: 'GET', url: '/cost/transaction/group' },
  // + `/{stockId}/price-per-unit` (DOF-1352; replaces /inventory/stock/{id}/price-per-unit)
  updateStockPricePerUnit: { method: 'PATCH', url: '/cost/stock' },
}
